/**
 * A form field's validation message. Give it the id the field names in
 * `aria-describedby` so the message is read with the field.
 */
export function FieldError({
  id,
  message,
}: {
  id: string
  message: string | undefined
}): React.JSX.Element | null {
  if (message === undefined) return null
  return (
    <p id={id} className="text-xs text-destructive">
      {message}
    </p>
  )
}
